"use client";

import { useEffect } from "react";

// Extend CSSStyleDeclaration to include vendor-specific properties
interface ExtendedCSSStyleDeclaration extends CSSStyleDeclaration {
    mozUserSelect?: string;
    msUserSelect?: string;
}

export function DisableDevTools() {
    useEffect(() => {
        // Touch devices (incl. iPadOS, which reports a Mac UA) have no devtools to detect, and their
        // on-screen keyboard shrinks innerHeight, which the size check below mistakes for open devtools
        const isTouchDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
            || window.matchMedia("(pointer: coarse)").matches;

        // Disable right-click context menu
        const disableContextMenu = (e: MouseEvent) => {
            e.preventDefault();
            return false;
        };

        // Disable key combinations for developer tools
        const disableKeyboardShortcuts = (e: KeyboardEvent) => {
            // F12 key
            if (e.key === "F12") {
                e.preventDefault();
                return false;
            }

            // Ctrl+Shift+I (Windows/Linux) or Cmd+Option+I (Mac)
            if (e.ctrlKey && e.shiftKey && e.key === "I") {
                e.preventDefault();
                return false;
            }

            // Ctrl+Shift+J (Windows/Linux) or Cmd+Option+J (Mac) - Console
            if (e.ctrlKey && e.shiftKey && e.key === "J") {
                e.preventDefault();
                return false;
            }

            // Ctrl+Shift+C (Windows/Linux) or Cmd+Option+C (Mac) - Element inspector
            if (e.ctrlKey && e.shiftKey && e.key === "C") {
                e.preventDefault();
                return false;
            }

            // Ctrl+U (Windows/Linux) or Cmd+U (Mac) - View source
            if (e.ctrlKey && e.key === "u") {
                e.preventDefault();
                return false;
            }

            // Ctrl+S (Windows/Linux) or Cmd+S (Mac) - Save page
            if (e.ctrlKey && e.key === "s") {
                e.preventDefault();
                return false;
            }

            // F3 or Ctrl+F - Find
            if (e.key === "F3" || (e.ctrlKey && e.key === "f")) {
                e.preventDefault();
                return false;
            }

            // Escape key
            if (e.key === "Escape") {
                e.preventDefault();
                return false;
            }
        };

        // Disable text selection
        const disableSelection = () => {
            document.body.style.userSelect = "none";
            document.body.style.webkitUserSelect = "none";
            (document.body.style as ExtendedCSSStyleDeclaration).mozUserSelect = "none";
            (document.body.style as ExtendedCSSStyleDeclaration).msUserSelect = "none";
        };

        // Disable drag and drop
        const disableDragDrop = (e: DragEvent) => {
            e.preventDefault();
            return false;
        };

        // Console warning message
        const showConsoleWarning = () => {
            console.clear();
            console.warn(
                "%cSTOP!",
                "color: red; font-size: 50px; font-weight: bold;"
            );
            console.warn(
                "%cThis is a browser feature intended for developers. Unauthorized access to this console may violate terms of service.",
                "color: red; font-size: 16px;"
            );
            console.warn(
                "%cIf someone told you to copy-paste something here, it is likely a scam and may give them access to your account.",
                "color: red; font-size: 14px;"
            );
        };

        // Detect developer tools opening (DESKTOP ONLY)
        const detectDevTools = () => {
            const threshold = 160;
            let isDevToolsOpen = false;

            const checkDevTools = () => {
                const heightDiff = window.outerHeight - window.innerHeight;
                const widthDiff = window.outerWidth - window.innerWidth;
                
                if (heightDiff > threshold || widthDiff > threshold) {
                    if (!isDevToolsOpen) {
                        isDevToolsOpen = true;
                        // Redirect or show warning when dev tools are detected
                        window.location.href = "/";
                    }
                } else {
                    isDevToolsOpen = false;
                }
            };

            return setInterval(checkDevTools, 500);
        };

        // Add event listeners
        document.addEventListener("contextmenu", disableContextMenu);
        document.addEventListener("keydown", disableKeyboardShortcuts);
        document.addEventListener("dragstart", disableDragDrop);
        document.addEventListener("drop", disableDragDrop);
        
        // Apply selection disable
        disableSelection();
        
        // Show console warning
        showConsoleWarning();
        
        // Start dev tools detection (desktop only)
        const detectionInterval = isTouchDevice ? undefined : detectDevTools();

        // Cleanup function
        return () => {
            document.removeEventListener("contextmenu", disableContextMenu);
            document.removeEventListener("keydown", disableKeyboardShortcuts);
            document.removeEventListener("dragstart", disableDragDrop);
            document.removeEventListener("drop", disableDragDrop);
            
            // Re-enable text selection
            document.body.style.userSelect = "";
            document.body.style.webkitUserSelect = "";
            (document.body.style as ExtendedCSSStyleDeclaration).mozUserSelect = "";
            (document.body.style as ExtendedCSSStyleDeclaration).msUserSelect = "";
            
            // Clear detection interval
            clearInterval(detectionInterval);
        };
    }, []);

    return null; // This component doesn't render anything
}